document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-4)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('[data-detail-gallery]');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 1.5,
            spaceBetween: 5,
            initialSlide: 0,
            breakpoints: {
                320: {
                    slidesPerView: 1
                },
                992: {
                    slidesPerView: 1.5,
                    initialSlide: 1
                },
            }
        });
    }());
});